const DB_NAME = 'app-storage-db'
const STORE_NAME = 'keyval'
const DB_VERSION = 1

function openDB() {
  return new Promise((resolve, reject) => {
    const request = indexedDB.open(DB_NAME, DB_VERSION)

    request.onupgradeneeded = () => {
      const db = request.result
      if (!db.objectStoreNames.contains(STORE_NAME)) {
        db.createObjectStore(STORE_NAME)
      }
    }

    request.onsuccess = () => resolve(request.result)
    request.onerror = () => reject(request.error)
  })
}

async function withStore(type, callback) {
  const db = await openDB()
  return new Promise((resolve, reject) => {
    const tx = db.transaction(STORE_NAME, type)
    const store = tx.objectStore(STORE_NAME)

    const result = callback(store)

    tx.oncomplete = () => resolve(result)
    tx.onerror = () => reject(tx.error)
  })
}

export const indexedDbStorage = {
  async setItem(key, value) {
    // const sizeMB = (new Blob([JSON.stringify(value)]).size / 1024 / 1024).toFixed(2)
    // console.log('Size:', sizeMB, 'MB')
    return withStore('readwrite', (store) => store.put(JSON.stringify(value), key))
  },

  async getItem(key) {
    let request
    await withStore('readonly', (store) => {
      request = store.get(key)
    })
    return request?.result ? JSON.parse(request.result) : null
  },

  async removeItem(key) {
    return withStore('readwrite', (store) => store.delete(key))
  },

  async clear() {
    return withStore('readwrite', (store) => store.clear())
  },
}
